export default "__VITE_ASSET__B_oVd42i__"